import React from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import { Box } from "@material-ui/core";

import AllNotifications from "@jumbo/Dashboards/Notifications";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.notifications"} />, isActive: true },
];

const Notifications = () => {
  return (
    <PageContainer
      heading={<IntlMessages id="pages.notifications" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Box
            marginBottom={"10px"}
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <div>
              <IntlMessages id="pages.notifications.description" />
            </div>
          </Box>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <AllNotifications />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default Notifications;
